import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "tss_admin_token";

export const auth = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

const authHeader = () => {
  const t = auth.get();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminApi = {
  login: (password) =>
    axios.post(`${API}/admin/login`, { password }).then((r) => r.data),
  verify: () =>
    axios.get(`${API}/admin/verify`, { headers: authHeader() }).then((r) => r.data),
};

export const clientsApi = {
  list: () => axios.get(`${API}/clients`).then((r) => r.data),
  getBySlug: (slug) => axios.get(`${API}/clients/slug/${slug}`).then((r) => r.data),
  create: (data) =>
    axios.post(`${API}/clients`, data, { headers: authHeader() }).then((r) => r.data),
  update: (id, data) =>
    axios.put(`${API}/clients/${id}`, data, { headers: authHeader() }).then((r) => r.data),
  remove: (id) =>
    axios.delete(`${API}/clients/${id}`, { headers: authHeader() }).then((r) => r.data),
};

export default clientsApi;
